import { Info } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const CLASSIFICATION_RULES = [
  {
    level: "SCĂZUT",
    levelDisplay: "Scăzut",
    annex1Result: "Nu intră sub incidența legii",
    annex2Result: "Nu intră sub incidența legii",
    bgColorLevel: "bg-yellow-300",
    bgColorAnnex1Result: "bg-gray-500",
    bgColorAnnex2Result: "bg-gray-500",
  },
  {
    level: "MEDIU",
    levelDisplay: "Mediu",
    annex1Result: "Entitate importantă",
    annex2Result: "Entitate importantă",
    bgColorLevel: "bg-orange-500",
    bgColorAnnex1Result: "bg-green-300",
    bgColorAnnex2Result: "bg-green-300",
  },
  {
    level: "RIDICAT",
    levelDisplay: "Ridicat",
    annex1Result: "Entitate critică",
    annex2Result: "Entitate importantă",
    bgColorLevel: "bg-red-600",
    bgColorAnnex1Result: "bg-blue-600",
    bgColorAnnex2Result: "bg-green-300",
  },
] as const;

type ClassificationReferenceTableProps = {
  showTitle?: boolean;
  compact?: boolean;
};

export function ClassificationReferenceTable({
  showTitle = true,
  compact = false,
}: ClassificationReferenceTableProps) {
  return (
    <Card className="border-primary/20">
      {showTitle && (
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base md:text-lg">
            <Info className="h-5 w-5" />
            Ghid de Clasificare conform Art. 9
          </CardTitle>
          <CardDescription className="text-xs md:text-sm">
            Clasificarea entităților în funcție de rezultatul analizei privind
            efectul perturbator
          </CardDescription>
        </CardHeader>
      )}
      <CardContent className={showTitle ? "pt-0 md:pt-0" : ""}>
        <div className="overflow-x-auto">
          <Table className="border-2 border-black">
            <TableHeader>
              <TableRow className="border-2 border-black">
                <TableHead
                  rowSpan={2}
                  className="p-1 text-xs md:text-sm border-r-2 border-black align-middle bg-blue-400 text-black font-bold text-center"
                >
                  {/* Empty cell */}
                </TableHead>
                <TableHead
                  rowSpan={2}
                  className="p-1 text-xs md:text-sm border-r-2 border-black align-middle bg-blue-400 text-black font-bold text-center"
                >
                  Nivelul efectului perturbator
                </TableHead>
                <TableHead
                  colSpan={2}
                  className="p-1 text-xs md:text-sm border-black align-middle bg-blue-400 text-black font-bold text-center"
                >
                  Rezultat
                </TableHead>
              </TableRow>

              <TableRow className="border-2 border-black">
                <TableHead className="p-1 text-xs md:text-sm border-r-2 border-black align-middle bg-blue-200 text-black font-bold text-center">
                  Anexa nr. 1
                </TableHead>
                <TableHead className="p-1 text-xs md:text-sm border-black align-middle bg-blue-200 text-black font-bold text-center">
                  Anexa nr. 2
                </TableHead>
              </TableRow>
            </TableHeader>

            <TableBody>
              {CLASSIFICATION_RULES.map((rule, index) => (
                <TableRow key={rule.level} className="border-2 border-black">
                  {index === 0 && (
                    <TableCell
                      rowSpan={3}
                      className="p-2 text-xs md:text-sm border-r-2 border-black align-middle bg-blue-400 text-black font-bold text-center"
                    >
                      Cel mai mare rezultat <br /> conform art. 9 lit. b) și c)
                    </TableCell>
                  )}

                  <TableCell
                    className={`p-2 text-xs md:text-sm border-r-2 border-black align-middle ${rule.bgColorLevel} text-black font-semibold text-center`}
                  >
                    {rule.levelDisplay}
                  </TableCell>

                  <TableCell
                    className={`p-2 text-xs md:text-sm border-r-2 border-black align-middle ${rule.bgColorAnnex1Result} text-black font-semibold text-center`}
                  >
                    {rule.annex1Result}
                  </TableCell>

                  <TableCell
                    className={`p-2 text-xs md:text-sm border-black align-middle ${rule.bgColorAnnex2Result} text-black font-semibold text-center`}
                  >
                    {rule.annex2Result}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
